<template>
  <v-container fluid class="fill-height align-start">
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between mb-4">
        <div>
          <h1 class="text-h4 font-weight-bold ">Reporte de Egresos</h1>
          <span class="text-subtitle-1 grey--text text--darken-1">Análisis mensual detallado</span>
        </div>

        <v-card width="300" elevation="2" class="rounded-lg">
          <v-menu
            v-model="menu1"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDateFormattedMomentjs"
                prepend-inner-icon="mdi-calendar-month"
                readonly
                flat
                solo
                hide-details
                v-bind="attrs"
                v-on="on"
                class="rounded-lg"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaPeriodo"
              type="month"
              locale="es"
              no-title
              scrollable
              @change="fetchGastos"
              color="primary"
              :max="moment().format('YYYY-MM')"
            ></v-date-picker>
          </v-menu>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-card class="rounded-xl pa-4" elevation="1">
              <div class="d-flex align-center">
                <v-avatar color="primary lighten-4" size="48" class="mr-4">
                  <v-icon color="primary">mdi-cash-multiple</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text font-weight-bold uppercase">Total General</div>
                  <div class="text-h5 font-weight-black">{{ totalGastos | convertPesoArg }}</div>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="rounded-xl pa-4" elevation="1">
              <div class="d-flex align-center">
                <v-avatar color="orange lighten-4" size="48" class="mr-4">
                  <v-icon color="orange darken-2">mdi-chart-pie</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text font-weight-bold uppercase">Categorías</div>
                  <div class="text-h5 font-weight-bold">{{ totalGastosPorCategoria | convertPesoArg }}</div>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="rounded-xl pa-4" elevation="1">
              <div class="d-flex align-center">
                <v-avatar color="green lighten-4" size="48" class="mr-4">
                  <v-icon color="green darken-2">mdi-cart-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text font-weight-bold uppercase">Compras</div>
                  <div class="text-h5 font-weight-bold">{{ totalGastosCompra | convertPesoArg }}</div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" class="mt-4">
        <v-row v-if="cargando" justify="center" align="center" style="min-height: 300px;">
          <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-row>

        <v-row v-else>
          <v-col cols="12" md="6">
            <v-card class="rounded-xl pa-6 fill-height" elevation="2">
              <div class="text-h6 font-weight-bold mb-6 d-flex align-center">
                <v-icon small class="mr-2">mdi-label-outline</v-icon>
                Distribución por Gastos
              </div>
              <ChartGastosPorMes 
                v-if="chartGastos" 
                :chart-gastos="chartGastos" 
              />
              <v-alert v-else type="info" text class="mt-4">No hay datos de gastos</v-alert>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card class="rounded-xl pa-6 fill-height" elevation="2">
              <div class="text-h6 font-weight-bold mb-6 d-flex align-center">
                <v-icon small class="mr-2">mdi-basket-outline</v-icon>
                Análisis de Compras
              </div>
              <ChartComprasPorMes 
                v-if="chartGastosCompras" 
                :compras="chartGastosCompras" 
              />
              <v-alert v-else type="info" text class="mt-4">No hay datos de compras</v-alert>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChartComprasPorMes from "@/components/reportes/ChartComprasPorMes.vue";
import ChartGastosPorMes from "@/components/reportes/ChartGastosPorMes.vue";

export default {
  name: "reporte.gastos",
  components: {
    ChartComprasPorMes,
    ChartGastosPorMes,
  },
  data: () => ({
    chartGastos: null,
    chartGastosCompras: null,
    fechaPeriodo: new Date().toISOString().substr(0, 7),
    menu1: false,
    cargando: false
  }),
  computed: {
    totalGastosPorCategoria() {
      if (!this.chartGastos?.data) return 0;
      return this.chartGastos.data.reduce((acc, obj) => acc + (obj.total_categoria || 0), 0);
    },
    totalGastosCompra() {
      if (!this.chartGastosCompras?.data) return 0;
      return this.chartGastosCompras.data.reduce((acc, obj) => acc + (obj.total || 0), 0);
    },
    totalGastos() {
      return this.totalGastosCompra + this.totalGastosPorCategoria;
    },
    computedDateFormattedMomentjs() {
      return this.fechaPeriodo
        ? this.moment(this.fechaPeriodo).format("MMMM YYYY").toUpperCase()
        : "";
    },
  },
  methods: {
    buildGastosChart(data) {
      const items = data.categorias.map((cat) => ({
        id: cat.id,
        name: cat.nombre,
        color: cat.color,
        total_categoria: cat.total,
        tipos: cat.tipos,
      }));
      return {
        labels: items.map((d) => d.name),
        datasets: [{ backgroundColor: items.map((d) => d.color), data: items.map((d) => d.total_categoria) }],
        data: items,
      };
    },
    buildComprasChart(data) {
      const COLORS = ["#42A5F5", "#66BB6A", "#FFA726", "#AB47BC", "#26A69A", "#FF7043", "#EC407A", "#26C6DA"];
      const items = data.categorias.map((cat, i) => ({
        name: cat.categoria,
        total: cat.sucursales.reduce((sum, s) => sum + s.total, 0),
        color: COLORS[i % COLORS.length],
      }));
      return {
        labels: items.map((d) => d.name),
        datasets: [{ backgroundColor: items.map((d) => d.color), data: items.map((d) => d.total) }],
        data: items,
      };
    },
    async fetchGastos() {
      this.cargando = true;
      try {
        const desde = this.moment(this.fechaPeriodo).startOf("month").format("YYYY-MM-DD");
        const hasta = this.moment(this.fechaPeriodo).endOf("month").format("YYYY-MM-DD");
        const [resGastos, resCompras] = await Promise.all([
          this.axios.get(`/reportes/gastos/por-categoria?desde=${desde}&hasta=${hasta}`),
          this.axios.get(`/reportes/compras/por-categoria?desde=${desde}&hasta=${hasta}`)
        ]);
        this.chartGastos = this.buildGastosChart(resGastos.data);
        this.chartGastosCompras = this.buildComprasChart(resCompras.data);
      } catch (error) {
        console.error("Error cargando reportes", error);
      } finally {
        this.cargando = false;
      }
    }
  },
  created() {
    this.fetchGastos();
  },
};
</script>

<style scoped>
.uppercase {
  text-transform: uppercase;
  letter-spacing: 1px;
}
</style>